/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.alertsModule')
.directive('bulbMaintenanceAlert', bulbMaintenanceAlert);

function bulbMaintenanceAlert() {
  return {
    restrict: 'E',
    scope: true,
    controller: 'MaintenanceAlertController as maintenanceAlertCtrl',
    templateUrl: 'ajs/alerts/maintenancealert.html'
  };
}
